__turbopack_context__.v({
  "dot": "MobileCarousel-module__dvFVda__dot",
  "dotActive": "MobileCarousel-module__dvFVda__dotActive",
  "dots": "MobileCarousel-module__dvFVda__dots",
  "root": "MobileCarousel-module__dvFVda__root",
  "slide": "MobileCarousel-module__dvFVda__slide",
  "track": "MobileCarousel-module__dvFVda__track",
  "viewport": "MobileCarousel-module__dvFVda__viewport",
});
